import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import fetchUserData from '../FetchUserData'


import CommonSetting from '../CommonSetting/CommonSetting'
import UserDropdown from './Components/UserDropdown'


const CommonHeader = ({ toggleSidebar, sidebarHidden }) => {
    const dispatch = useDispatch();

    const user = useSelector(
        (state) => state.user
    );

    useEffect(() => {
        const accessToken =
            localStorage.getItem("accessToken");

        if (user?.id == null && accessToken) {
            fetchUserData({
                dispatch,
                token: accessToken,
            });
        }
    }, [dispatch, user]);

    return (
        <>
            <header className="px-xl-5 px-lg-4 px-3 sticky-top z-3" id='headerDark' data-bs-theme="none">
                <div className="d-flex justify-content-between align-items-center py-2 w-100">
                    <div className="d-flex align-items-center pe-4">
                        <button className="btn d-inline-flex d-xl-none border-0 p-0 pe-2" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvas_Navbar">
                            <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3" /><path d="M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z" fill="var(--accent-color)" /><path d="M15 12h-8" /><path d="M10 9l-3 3l3 3" /></svg>
                        </button>
                        <button className="btn d-xl-inline-flex d-none border-0 p-0 pe-2 sidebar-toggle-btn" type="button" onClick={toggleSidebar}>
                            <svg xmlns="http://www.w3.org/2000/svg" className="svg-stroke" width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 21a3 3 0 0 1 -3 -3v-12a3 3 0 0 1 3 -3" /><path d="M21 6v12a3 3 0 0 1 -6 0v-12a3 3 0 0 1 6 0z" fill="var(--accent-color)" /><path d="M15 12h-8" /><path d="M10 9l-3 3l3 3" /></svg>
                        </button>
                        {/* <!--[ Start:: Brand Logo icon ]--> */}
                        <Link to="/" className={`${sidebarHidden ? 'd-xl-flex d-none' : 'd-none'} brand-icon text-decoration-none align-items-center`} title="PatidarSamaj Admin Template">
                            <span className="fw-bold ps-2 fs-5 d-inline-flex text-gradient align-items-center gap-2">
                                <img height={"30px"} width={"30px"} src={`${user.logo}`} alt="avatar" />
                                PatidarSamaj
                            </span>
                        </Link>
                        <Link to="/" className={`d-xl-none d-flex brand-icon text-decoration-none align-items-center`} title="PatidarSamaj Admin Template">
                            <span className="fw-bold ps-2 fs-5 d-inline-flex text-gradient align-items-center gap-2">
                                <img height={"30px"} width={"30px"} src={`${user.logo}`} alt="avatar" />
                                PatidarSamaj
                            </span>
                        </Link>
                    </div>

                    <ul className="header-menu flex-grow-1">
                        {/* <!--[ Start:: theme setting ]--> */}
                        <div className="nav-item dropdown px-md-1">
                            <Link className="dropdown-toggle gray-6" to="#offcanvas_setting" data-bs-toggle="offcanvas" aria-expanded="false" title="template setting">
                                <svg className="svg-stroke" xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                                    <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
                                </svg>
                            </Link>
                        </div>
                        <li className="nav-item py-2 py-md-1 col-auto">
                            <div className="vr d-none d-sm-flex h-100 mx-sm-2"></div>
                        </li>
                        {/* <!--[ Start:: user detail ]--> */}
                        <li className="nav-item user ms-3">
                            <Link className="dropdown-toggle gray-6 d-flex text-decoration-none align-items-center lh-sm p-0" to="/" role="button" data-bs-toggle="dropdown" aria-expanded="false" title="User" data-bs-auto-close="outside">
                                {user.image ? (
                                    <img className="avatar rounded-circle border border-3"
                                        src={user.image} alt="avatar"
                                        onError={(e) => {
                                            e.target.style.display = 'none';
                                            e.target.nextSibling.style.display = 'flex';
                                        }}
                                    />
                                ) : null}
                                <div className="avatar rounded-circle border border-3 align-items-center justify-content-center bg-primary text-white fw-semibold"
                                    style={{ fontSize: '0.85rem', userSelect: 'none', display: user.image ? 'none' : 'flex' }}>
                                    {user.name
                                        ?.split(" ")
                                        .slice(0, 2)
                                        .map(w => w[0]?.toUpperCase())
                                        .join("")
                                    }
                                </div>
                                <span className="ms-2 fs-6 d-none d-sm-inline-flex">{user.name}</span>
                            </Link>
                            <UserDropdown />
                        </li>
                    </ul>
                </div>
            </header>
            <CommonSetting />
        </>
    )
}

export default CommonHeader